<template>
  <b-modal
    v-model="editorShown"
    title="Verification Response"
    size="lg"
    centered
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <div class="eligibility-response-container" v-if="requestRendered">
      <p v-html-sanitize="requestRendered.htmlDocument"></p>
    </div>
  </b-modal>
</template>

<script>
import eligibilityVerificationServer from "../../server/eligibilityVerification";

export default {
  name: "EligibilityRequestRenderModal",
  props: ["eligibilityVerificationId"],
  data() {
    return {
      requestRendered: null
    };
  },
  async mounted() {
    this.fetchEligibilityRequestRendered();
  },
  methods: {
    async fetchEligibilityRequestRendered() {
      const requestRendered = await eligibilityVerificationServer.renderResponse(
        this.eligibilityVerificationId
      );
      this.requestRendered = requestRendered;
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
.eligibility-response-container {
  height: calc(100vh - 220px);
  overflow-y: auto;
}
</style>
